import { useEffect, useState } from 'react'
import { QueryStatus } from 'src/types'
import { HttpCacheWorkflow } from 'src/http/workflow/httpCacheWorkflow'
import { SistemaPrincipal } from 'src/types/workflow/cache'
import {HttpSystems} from "../../../http/workflow/httpSystems";

export const useSistemasPrincipales = () => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [sistemasPrincipales, setSistemasPrincipales] = useState<SistemaPrincipal[]>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        //HttpCacheWorkflow.getSistemasPrincipales()
        HttpSystems.getSystemPrincipalsByUser()
            .then(res => {
                setSistemasPrincipales(res)
                setStatus(QueryStatus.Success)
            })
            .catch(() => setStatus(QueryStatus.Error))
    }, [])

    return { status, sistemasPrincipal: sistemasPrincipales }
}
